import { combineReducers } from 'redux';
import loadingVersion from './loadingVersionReducer';
import item from './itemReducer';
import refreshVersion from './refreshVersionReducer';

export default combineReducers({
  loadingVersion,
  item,
  refreshVersion,
});